import type { HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export interface BannerWithTitleProps extends HTMLAttributes<HTMLDivElement> {
  title: string
}

export function BannerWithTitle({ title, className }: BannerWithTitleProps) {
  return (
    <div
      className={twMerge(
        '2xl:h-banner flex h-52 w-full items-center justify-center rounded-2xl bg-cover bg-bottom-right xl:h-104',
        className,
      )}
    >
      <div className="bg-monochromatic-500/50 size-full content-center rounded-2xl px-4 text-center lg:px-24">
        <h1 className="banner-title text-shadow-title text-center text-2xl text-white md:px-0 md:text-4xl md:text-white xl:text-5xl 2xl:text-6xl">
          {title}
        </h1>
      </div>
    </div>
  )
}
